import {
	fromDocumentIdString,
	parseCardDocumentId,
	parseChatDocumentId,
	parseWhiteboardDocumentId,
} from "@src/components/collaboration/document-id";
import { isDocumentId } from "@src/components/collaboration/document-id/validation";

export function sameChatId(a: string, b: string): boolean {
	return parseChatDocumentId(a).id === parseChatDocumentId(b).id;
}

export function chatAggregateId(ref: string): string {
	return parseChatDocumentId(ref).toIdString();
}

export function sameWhiteboardId(a: string, b: string): boolean {
	return parseWhiteboardDocumentId(a).id === parseWhiteboardDocumentId(b).id;
}

export function whiteboardAggregateId(ref: string): string {
	return parseWhiteboardDocumentId(ref).toIdString();
}

export function whiteboardTypedId(ref: string): string {
	return parseWhiteboardDocumentId(ref).toString();
}

export function sameCardId(a: string, b: string): boolean {
	const left = parseCardDocumentId(a);
	const right = parseCardDocumentId(b);
	return left.type === right.type && left.id === right.id;
}

export function cardTypedId(ref: string): string {
	return parseCardDocumentId(ref).toString();
}

export function cardAggregateId(ref: string): string {
	return parseCardDocumentId(ref).toIdString();
}

/** Typed document ids use their type. Untyped refs are card aggregate ids. */
export function attachedEntityKind(ref: string): "whiteboard" | "card" | null {
	if (!isDocumentId(ref)) {
		return "card";
	}
	const doc = fromDocumentIdString(ref);
	if (doc.type === "whiteboard") {
		return "whiteboard";
	}
	if (doc.type === "card" || doc.type === "preprint") {
		return "card";
	}
	return null;
}
